<template>
  <div class="employeeslist">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Employee</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Employee</li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto">
                <div class="row">
                  <div class="col-md-3">
                    <button
                      class="btn btn-primary dropdown-toggle"
                      type="button"
                      id="dropdownMenuButton1"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      Filter
                    </button>
                    <div
                      class="dropdown-menu"
                      aria-labelledby="dropdownMenuButton1"
                    >
                      <a class="dropdown-item" @click="GetEmployees"
                        >Active Employees</a
                      >
                      <a class="dropdown-item" @click="GetExitEmployees"
                        >Exit Employees</a
                      >
                    </div>
                  </div>
                  <div class="col-md-3">
                    <button
                      class="btn btn-primary dropdown-toggle view-icons"
                      type="button"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      More
                    </button>
                    <div
                      class="dropdown-menu"
                      aria-labelledby="dropdownMenuButton"
                    >
                      <a class="dropdown-item" @click="openImportDialog"
                        >Import Employee</a
                      >
                      <a class="dropdown-item" @click="openImportDDialog"
                        >Import Employee Details</a
                      >
                      <a class="dropdown-item" @click="exportEmployee"
                        >Export</a
                      >
                    </div>
                  </div>
                  <div class="col-md-6">
                    <a class="btn add-btn" @click="openDialog"
                      ><i class="fa fa-plus"></i> Add Employee</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <!-- Search Filter -->
          <div class="row filter-row">
            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus">
                <input
                  type="text"
                  class="form-control floating"
                  v-model="filterEmpId"
                  @keyup="employeeCodesearch"
                  style="height: 55px !important"
                />
                <label class="focus-label">Employee Code</label>
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus">
                <input
                  type="text"
                  class="form-control floating"
                  v-model="filterEmpName"
                  @keyup="looksearch"
                  style="height: 55px !important"
                />
                <label class="focus-label">Employee Name</label>
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus select-focus">
                <multiselectvue
                  class="from-control"
                  v-model="newEmployeeDesignationForSearch"
                  placeholder="Select Designation"
                  :custom-label="nameOfDesignationForSearch"
                  :options="sortedEmployeeDesignation"
                  :searchable="true"
                  @select="optionSelectDesignationForSearch"
                  :allow-empty="false"
                >
                  <template slot="singleLabel" slot-scope="{ option }">{{
                    option.name
                  }}</template>
                </multiselectvue>
                <!-- <select
                  class="form-control"
                  style="height: 55px !important"
                  v-model="filterDesignationId"
                >
                  <option>Select Designation</option>
                  <option
                    v-for="item in designations"
                    :key="item.id"
                    :value="parseInt(item.id)"
                  >
                    {{ item.name }}
                  </option>
                </select> -->
                <!-- <label class="focus-label">Designation</label> -->
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <a @click="getFilter" class="btn btn-success btn-block">
                Search
              </a>
            </div>
          </div>
          <!-- /Search Filter -->
          <!----Datatable-->
          <div class="row">
            <div class="col-md-12">
              <v-data-table
                :headers="headers"
                :items="searchEmployeeList"
                :loading="loading"
                loading-text="Loading... Please wait"
                sort-by=""
                class="elevation-1 table"
              >
                <template v-slot:[`item.profile`]="{ item }">
                  <h2 class="table-avatar">
                    <router-link
                      :to="{ name: 'employeedetail', params: { id: item.id } }"
                      class="avatar"
                      ><img
                        alt=""
                        src="~@/assets/profiles/avatar-02.jpg"
                        v-if="!item.passportPhoto"/>
                      <img
                        alt=""
                        :src="media + item.passportPhoto"
                        width="38"
                        v-if="item.passportPhoto"
                    /></router-link>
                    <router-link
                      :to="{ name: 'employeedetail', params: { id: item.id } }"
                      v-if="item.status == 3"
                      ><p>{{ item.fullName }}</p>
                      <span>{{ item.designation.name }}</span>
                    </router-link>
                    <router-link
                      :to="{ name: 'employeedetail', params: { id: item.id } }"
                      v-else
                      >{{ item.fullName }}
                      <span>{{ item.designation.name }}</span>
                    </router-link>
                  </h2>
                </template>
                <template v-slot:[`item.joinDate`]="{ item }">
                  {{
                    item.joinDate
                      ? new Date(item.joinDate).toLocaleDateString()
                      : ""
                  }}
                </template>
                <template v-slot:[`item.employeeCode`]="{ item }">
                  {{ item.employeeCode }}
                </template>

                <template v-slot:[`item.actions`]="{ item }">
                  <div class="dropdown dropdown-action">
                    <a
                      href="#"
                      class="action-icon dropdown-toggle"
                      data-toggle="dropdown"
                      aria-expanded="false"
                      ><i class="material-icons">more_vert</i></a
                    >
                    <div class="dropdown-menu dropdown-menu-right">
                      <a
                        class="dropdown-item"
                        @click="setEditEmployee(item)"
                        data-toggle="modal"
                        data-target="#edit_employee"
                        v-if="item.status < 3"
                        ><i class="fa fa-pencil m-r-5"></i> Edit</a
                      >
                      <a
                        class="dropdown-item"
                        @click="setDeletEmployee(item)"
                        v-if="item.status < 3"
                        data-toggle="modal"
                        data-target="#delete_employee"
                        ><i class="fa fa-trash-o m-r-5"></i> Delete</a
                      >

                      <a
                        class="dropdown-item"
                        @click="setExitEmployee(item)"
                        v-if="item.status < 3"
                        data-toggle="modal"
                        data-target="#delete_employee"
                        ><i class="fa fa-trash-o m-r-5"></i> Exit</a>
                      <a
                      class="dropdown-item"
                      @click="setConsiderEmployee(item)"
                      v-if="item.status === 8"
                      data-toggle="modal"
                      data-target="#delete_employee"
                      ><i class="fa fa-trash-o m-r-5"></i>Reconsider</a>
                    </div>
                  </div>
                </template>
              </v-data-table>
            </div>
          </div>
          <!---/Datatable-->
        </div>
        <!-- /Page Content -->

        <!-- Add Employee Modal -->
        <v-dialog v-model="dialogAdd" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Add Employee</h5>
              <button type="button" class="close" @click="close1">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="onSubmit">
                <div class="row">
                  <div class="col-md-12">
                    <div
                      class="alert alert-danger alert-dismissible fade show"
                      role="alert"
                      v-if="error"
                    >
                      <strong>Error!</strong> {{ error }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div
                      class="alert alert-success alert-dismissible fade show"
                      role="alert"
                      v-if="message"
                    >
                      <strong>Success!</strong> {{ message }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="col-form-label"
                        >First Name <span class="text-danger">*</span></label
                      >
                      <input
                        type="text"
                        v-model.trim="$v.firstName.$model"
                        id="name"
                        name="name"
                        class="form-control"
                        :class="{
                          'is-invalid': submitted && $v.firstName.$error
                        }"
                      />
                      <div
                        v-if="submitted && !$v.firstName.required"
                        class="invalid-feedback"
                      >
                        First Name is required
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="col-form-label">Last Name</label>
                      <input
                        type="text"
                        v-model.trim="$v.lastName.$model"
                        id="name"
                        name="name"
                        class="form-control"
                        :class="{
                          'is-invalid': submitted && $v.lastName.$error
                        }"
                      />
                      <div
                        v-if="submitted && !$v.lastName.required"
                        class="invalid-feedback"
                      >
                        Last Name is required
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="col-form-label"
                        >Email <span class="text-danger">*</span></label
                      >
                      <input
                        type="email"
                        v-model.trim="$v.email.$model"
                        id="email"
                        name="email"
                        class="form-control"
                        :class="{ 'is-invalid': submitted && $v.email.$error }"
                      />
                      <div
                        v-if="submitted && $v.email.$error"
                        class="invalid-feedback"
                      >
                        <span v-if="!$v.email.required">Email is required</span>
                        <span v-if="!$v.email.email">Email is invalid</span>
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="col-form-label">Phone </label>
                      <input
                        type="text"
                        v-model.trim="$v.phone.$model"
                        id="name"
                        name="name"
                        class="form-control"
                        :class="{ 'is-invalid': submitted && $v.phone.$error }"
                      />
                      <div
                        v-if="submitted && !$v.phone.required"
                        class="invalid-feedback"
                      >
                        Phone is required
                      </div>
                      <div
                        v-if="submitted && !$v.phone.numeric"
                        class="invalid-feedback"
                      >
                        Phone must be numbers
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label
                        >Business Unit <span class="text-danger">*</span></label
                      >
                      <select
                        class="form-control"
                        v-model.trim="$v.companyunitId.$model"
                        :class="{
                          'is-invalid': submitted && $v.companyunitId.$error
                        }"
                      >
                        <option disabled>Select Business Unit</option>
                        <option
                          v-for="item in units"
                          :key="item.id"
                          :value="parseInt(item.id)"
                        >
                          {{ item.name }}
                        </option>
                      </select>
                      <div
                        v-if="submitted && !$v.companyunitId.required"
                        class="invalid-feedback"
                      >
                        Business Unit is required
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label
                        >Designation <span class="text-danger">*</span></label
                      >

                      <multiselectvue
                        class="from-control"
                        v-model.trim="$v.newEmployeeDesignation.$model"
                        placeholder="Select Designation"
                        :custom-label="nameOfDesignation"
                        :options="sortedEmployeeDesignation"
                        :searchable="true"
                        @select="optionSelectDesignation"
                        :allow-empty="false"
                        :class="{
                          'is-invalid':
                            submitted && $v.newEmployeeDesignation.$error
                        }"
                      >
                        <template slot="singleLabel" slot-scope="{ option }">{{
                          option.name
                        }}</template>
                      </multiselectvue>

                      <div
                        v-if="submitted && !$v.newEmployeeDesignation.required"
                        class="invalid-feedback"
                      >
                        Designation is required
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Level <span class="text-danger">*</span></label>

                      <multiselectvue
                        class="from-control"
                        v-model.trim="$v.selectRank.$model"
                        placeholder="Select Rank"
                        :custom-label="nameOfRank"
                        :options="sortedEmployeeRanks"
                        :searchable="true"
                        @select="optionSelectRank"
                        :allow-empty="false"
                        :class="{
                          'is-invalid': submitted && $v.selectRank.$error
                        }"
                      >
                        <template slot="singleLabel" slot-scope="{ option }">{{
                          option.rankName
                        }}</template>
                      </multiselectvue>
                      <div
                        v-if="submitted && !$v.selectRank.required"
                        class="invalid-feedback"
                      >
                        Level is required
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="col-form-label">Employee Code</label>
                      <input
                        type="text"
                        v-model.trim="$v.employeeCode.$model"
                        id="name"
                        name="name"
                        class="form-control"
                        :class="{
                          'is-invalid': submitted && $v.employeeCode.$error
                        }"
                      />
                      <div
                        v-if="submitted && !$v.employeeCode.required"
                        class="invalid-feedback"
                      >
                        Employee Code is required
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Joined Date</label>
                      <div class="cal-icon">
                        <datepicker
                          v-model="$v.joinedDate.$model"
                          bootstrap-styling
                          class="datetimepicker"
                          type="date"
                          :class="{
                            'is-invalid': submitted && $v.joinedDate.$error
                          }"
                        />
                      </div>
                      <div
                        v-if="submitted && !$v.joinedDate.required"
                        class="invalid-feedback"
                      >
                        Joined Date is required
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="col-form-label">Branch</label>
                      <input
                        type="text"
                        v-model="branch"
                        id="name"
                        name="name"
                        class="form-control"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label>District</label>
                      <input
                        type="text"
                        v-model="district"
                        id="name"
                        name="name"
                        class="form-control"

                      />
                    </div>
                  </div>
                </div>

                <div class="submit-section">
                  <button
                    class="btn btn-primary submit-btn"
                    type="submit"
                    :disable="submitted"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>

        <!-- /Add Employee Modal -->

        <!-- Edit Employee Modal -->
        <v-dialog v-model="dialogEdit" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Edit Employee</h5>
              <button
                type="button"
                class="close"
                aria-label="Close"
                @click="close2"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="onPutSubmit">
                <div class="row">
                  <div class="col-md-12">
                    <div
                      class="alert alert-danger alert-dismissible fade show"
                      role="alert"
                      v-if="error"
                    >
                      <strong>Error!</strong> {{ error }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div
                      class="alert alert-success alert-dismissible fade show"
                      role="alert"
                      v-if="message"
                    >
                      <strong>Success!</strong> {{ message }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="col-form-label"
                        >First Name <span class="text-danger">*</span></label
                      >
                      <input
                        class="form-control"
                        v-model="employee.firstName"
                        type="text"
                        v-if="employee"
                      />
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="col-form-label">Last Name</label>
                      <input
                        class="form-control"
                        v-model="employee.lastName"
                        type="text"
                        v-if="employee"
                      />
                    </div>
                  </div>
                  <!-- <div class="col-sm-6">
                    <div class="form-group">
                      <label class="col-form-label"
                        >Email <span class="text-danger">*</span></label
                      >
                      <input
                        class="form-control"
                        v-model="employee.email"
                        type="email"
                        v-if="employee"
                      />
                    </div>
                  </div> -->
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="col-form-label">Phone </label>
                      <input
                        class="form-control"
                        v-model="employee.phone"
                        type="text"
                        v-if="employee"
                      />
                    </div>
                  </div>
                  <!-- <div class="col-md-6">
                    <div class="form-group">
                      <label
                        >Business Unit <span class="text-danger">*</span></label
                      >
                      <select
                        class="form-control"
                        v-model="employee.companyUnitId"
                        v-if="employee"
                      >
                        <option>Select Business Unit</option>
                        <option
                          v-for="item in units"
                          :key="item.id"
                          :value="parseInt(item.id)"
                        >
                          {{ item.name }}
                        </option>
                      </select>
                    </div>
                  </div> -->
                  <div class="col-md-6">
                    <div class="form-group">
                      <label
                        >Designation <span class="text-danger">*</span></label
                      >
                      <select
                        class="form-control"
                        v-model="employee.designationId"
                        v-if="employee"
                      >
                        <option>Select Designation</option>
                        <option
                          v-for="item in designations"
                          :key="item.id"
                          :value="parseInt(item.id)"
                        >
                          {{ item.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Level <span class="text-danger">*</span></label>

                      <select
                        class="form-control"
                        v-model="employee.rankId"
                        v-if="employee"
                      >
                        <option>Select Level</option>
                        <option
                          v-for="item in ranks"
                          :key="item.id"
                          :value="parseInt(item.id)"
                        >
                          {{ item.rankName }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="col-form-label">Employee Code </label>
                      <input
                        class="form-control"
                        v-model="employee.employeeCode"
                        type="text"
                        v-if="employee"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Joined Date</label>
                      <div class="cal-icon">
                        <datepicker
                          v-model="employee.joinDate"
                          bootstrap-styling
                          class="datetimepicker"
                          type="date"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="col-form-label">Branch </label>
                      <input
                        class="form-control"
                        v-model="employee.branch"
                        type="text"
                        v-if="employee"
                      />
                    </div>
                  </div>

                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="col-form-label">District </label>
                      <input
                        class="form-control"
                        v-model="employee.district"
                        type="text"
                        v-if="employee"
                      />
                    </div>
                  </div>
                </div>
                <div class="submit-section">
                  <button class="btn btn-primary submit-btn" type="submit">
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>
        <!-- /Edit Employee Modal -->

        <!-- Delete Employee Modal -->
        <v-dialog v-model="dialogDelete" max-width="725px">
          <div class="modal-content">
            <div class="modal-body">
              <div class="form-header">
                <button
                  type="button"
                  class="close"
                  aria-label="Close"
                  @click="closeDelete"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
                <h3>Delete Employee</h3>
                <p>Are you sure want to delete?</p>
              </div>
              <div class="modal-btn delete-action">
                <div class="row">
                  <div class="col-6">
                    <a
                      @click="removeEmployee"
                      class="btn btn-primary continue-btn"
                      data-dismiss="modal"
                    >
                      Delete</a
                    >
                  </div>
                  <div class="col-6">
                    <a
                      href="javascript:void(0);"
                      data-dismiss="modal"
                      class="btn btn-primary cancel-btn"
                      @click="closeDelete"
                      >Cancel</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- /Delete Employee Modal -->
        <!-- Delete Employee Modal -->
        <v-dialog v-model="dialogImport" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Import Employee</h5>
              <button
                type="button"
                class="close"
                aria-label="Close"
                @click="closeImport"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <div
                    class="alert alert-danger alert-dismissible fade show"
                    role="alert"
                    v-if="error"
                  >
                    <strong>Error!</strong> {{ error }}
                    <button
                      type="button"
                      class="close"
                      data-dismiss="alert"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>
              </div>
              <div class="form-header">
                <h3>Import Employee</h3>
                <p>
                  Download an excel template by clicking on the below button
                </p>
                <br />
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <p>
                    Note: please do not change the layout of the cells in the
                    excel, you are expected to add your data below the column
                    header (first row). <br />
                    Regards <strong>Designation</strong> and
                    <strong>Level</strong> columns you are expected to get the
                    value from their representing sheet. <br />
                  </p>
                </div>
                <div class="col-12">
                  <a
                    @click="downloadTemplate"
                    class="btn btn-primary continue-btn"
                    data-dismiss="modal"
                  >
                    Download Template</a
                  >
                </div>
              </div>
              <hr />
              <hr />
              <div class="row">
                <div class="col-sm-9">
                  <div class="form-group">
                    <label>Upload File</label>
                    <div class="custom-file">
                      <input
                        type="file"
                        name="file"
                        class="form-control"
                        id="cv_upload"
                        @change="onFilePicked"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-3">
                  <a
                    @click="importEmployee"
                    v-if="file"
                    class="btn btn-primary continue-btn"
                    data-dismiss="modal"
                  >
                    Import</a
                  >
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- /Delete Employee Modal -->
        <!-- Delete Employee Modal -->
        <v-dialog v-model="dialogDImport" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Import Employee Detail</h5>
              <button
                type="button"
                class="close"
                aria-label="Close"
                @click="closeDImport"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <div
                    class="alert alert-danger alert-dismissible fade show"
                    role="alert"
                    v-if="error"
                  >
                    <strong>Error!</strong> {{ error }}
                    <button
                      type="button"
                      class="close"
                      data-dismiss="alert"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>
              </div>
              <div class="form-header">
                <h3>Import Employee Detail</h3>
                <p>
                  Download an excel template by clicking on the below button
                </p>
                <br />
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <p>
                    Note: please do not change the layout of the cells in the
                    excel, you are expected to add your data below the column
                    header (first row). <br />
                    Regards you are expected to get the
                    value from their representing sheet. <br />
                  </p>
                </div>
                <div class="col-12">
                  <a
                    @click="downloadTemplate"
                    class="btn btn-primary continue-btn"
                    data-dismiss="modal"
                  >
                    Download Template</a
                  >
                </div>
              </div>
              <hr />
              <hr />
              <div class="row">
                <div class="col-sm-9">
                  <div class="form-group">
                    <label>Upload File</label>
                    <div class="custom-file">
                      <input
                        type="file"
                        name="file"
                        class="form-control"
                        id="cv_upload"
                        @change="onFilePicked"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-3">
                  <a
                    @click="importEmployeeDetail"
                    v-if="file"
                    class="btn btn-primary continue-btn"
                    data-dismiss="modal"
                  >
                    Import</a
                  >
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- /Delete Employee Modal -->
        <!-- Exit Employee Modal -->
        <v-dialog v-model="dialogExit" max-width="725px">
          <div class="modal-content">
            <div class="modal-body">
              <div class="form-header">
                <button
                  type="button"
                  class="close"
                  aria-label="Close"
                  @click="closeExit"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
                <h3>Exit Employee</h3>
                <p>Are you sure want to exit?</p>
              </div>
              <div class="modal-btn delete-action">
                <div class="row">
                  <div class="col-6">
                    <a
                      @click="exitEmployee"
                      class="btn btn-primary continue-btn"
                      data-dismiss="modal"
                    >
                      Exit</a
                    >
                  </div>
                  <div class="col-6">
                    <a
                      href="javascript:void(0);"
                      data-dismiss="modal"
                      class="btn btn-primary cancel-btn"
                      @click="closeExit"
                      >Cancel</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- /Exit Employee Modal -->
        <!-- Exit Employee Modal -->
        <v-dialog v-model="dialogConsider" max-width="725px">
          <div class="modal-content">
            <div class="modal-body">
              <div class="form-header">
                <button
                  type="button"
                  class="close"
                  aria-label="Close"
                  @click="closeExit"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
                <h3>Reconsider Employee</h3>
                <p>Are you sure want to reconsider this employee for employment?</p>
              </div>
              <div class="modal-btn delete-action">
                <div class="row">
                  <div class="col-6">
                    <a
                      @click="reconsiderEmployee"
                      class="btn btn-primary continue-btn"
                      :disabled="loading"
                    >
                      {{ !loading ? 'Reconsider' : 'Please wait...'}}</a
                    >
                  </div>
                  <div class="col-6">
                    <a
                      href="javascript:void(0);"
                      data-dismiss="modal"
                      class="btn btn-primary cancel-btn"
                      @click="closeConsider"
                      >Cancel</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- /Exit Employee Modal -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import { required, numeric, sameAs } from "vuelidate/lib/validators";
import { employeeService } from "@/services/employeeService.js";
import { authenticationService } from "@/services/authenticationService";
import { organizationService } from "@/services/organizationService";
import Datepicker from "vuejs-datepicker";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Datepicker
  },
  data() {
    return {
      company: authenticationService.currentOfficeValue,
      firstName: "",
      lastName: "",
      rankId: null,
      address: "",
      phone: "",
      employeeCode: "",
      email: "",
      branch: "",
      district: "",
      joinedDate: new Date(),
      designationId: null,
      newEmployeeDesignation: null,
      newEmployeeDesignationForSearch: null,
      companyunitId: null,
      media: "data:image/jpeg;base64,",
      headers: [
        {
          text: "Name",
          value: "profile"
        },
        { text: "Employee Code", value: "employeeCode" },
        { text: "Bus. Unit", value: "companyUnit.name" },
        { text: "Email", value: "email" },
        { text: "Mobile", value: "phone" },
        { text: "Join Date", value: "joinDate" },
        { text: "Gender", value: "gender" },
        { text: "Branch", value: "branch" },
        { text: "District", value: "district" },
        { text: "Action", value: "actions", sortable: false }
      ],
      employees: [],
      employee: {},
      designations: [],
      units: [],
      ranks: null,
      selectRank: null,
      submitted: false,
      loading: false,
      error: "",
      message: "",
      dialogAdd: false,
      dialogEdit: false,
      dialogDelete: false,
      dialogExit: false,
      dialogImport: false,
      dialogConsider: false,
      dialogDImport: false,
      filterEmpId: "",
      filterEmpName: "",
      filterDesignationId: "",
      designationStrings: "",
      unitStrings: "",
      rankStrings: "",
      nofilterEmployees: [],
      employeeGroups: [],
      file: null,
      fileName: "",
      newData: []
    };
  },
  validations: {
    firstName: { required },
    lastName: { required },
    rankId: { required },
    selectRank: { required },
    joinedDate: { required },
    phone: { required, numeric },
    employeeCode: { required },
    email: { required },
    designationId: { required },
    newEmployeeDesignation: { required },
    companyunitId: { required }
  },

  watch: {
    // dialogAdd(val) {
    //   val || this.close1();
    // },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    dialogExit(val) {
      val || this.closeExit();
    },
    dialogEdit(val) {
      val || this.close2();
    }
  },
  created() {
    this.GetEmployees();
  },

  computed: {
    searchEmployeeList: function() {
      return this.employees.filter(
        d =>
          this.filterEmpName != ""
            ? d.firstName
                .toLowerCase()
                .includes(this.filterEmpName.toLowerCase()) ||
              d.lastName
                .toLowerCase()
                .includes(this.filterEmpName.toLowerCase())
            : true
        // d =>
        //   d.firstName.toLowerCase().match(this.filterEmpName.toLowerCase()) ||
        //   d.lastName.toLowerCase().match(this.filterEmpName.toLowerCase())
      );
    },

    searchEmployeeList: function() {
      function compare(a, b) {
        if (a.fullName.toLowerCase() < b.fullName.toLowerCase()) return -1;
        if (a.fullName.toLowerCase() > b.fullName.toLowerCase()) return 1;
        return 0;
      }

      return this.newData.sort(compare);
    },

    sortedEmployeeDesignation: function() {
      function compare(a, b) {
        if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
        if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
        return 0;
      }

      return this.designations.sort(compare);
    },
    sortedEmployeeRanks: function() {
      function compare(a, b) {
        if (a.rankName.toLowerCase() < b.rankName.toLowerCase()) return -1;
        if (a.rankName.toLowerCase() > b.rankName.toLowerCase()) return 1;
        return 0;
      }

      return this.ranks ? this.ranks.sort(compare) : this.ranks;
    }
  },

  methods: {
    nameOfDesignation({ name }) {
      return `${name}`;
    },

    optionSelectDesignation(option, id) {
      console.log(option.id);
      this.designationId = option.id;
    },

    nameOfDesignationForSearch({ name }) {
      return `${name}`;
    },

    optionSelectDesignationForSearch(option, id) {
      console.log(option.id, this.newEmployeeDesignationForSearch.id);

      this.filterDesignationId = option.id;
      console.log(typeof this.filterDesignationId);
    },

    nameOfRank({ rankName }) {
      return `${rankName}`;
    },

    optionSelectRank(option, id) {
      console.log(option.id);
      this.rankId = option.id;
    },

    GetDesignations() {
      organizationService.getDesignations().then(
        model => {
          this.designations = model;

          var designationStrings = "";
          model.forEach(t => {
            designationStrings += t.id + " - " + t.name + ", ";
          });
          this.designationStrings = designationStrings;
        },
        error => {
          this.error = error;
        }
      );
    },
    GetUnits() {
      organizationService.getCompanyUnits(this.company.id).then(
        model => {
          this.units = model;

          var unitStrings = "";
          model.forEach(t => {
            unitStrings += t.id + " - " + t.name + ", ";
          });
          this.unitStrings = unitStrings;
        },
        error => {
          this.error = error;
        }
      );
    },
    onFilePicked(event) {
      const files = event.target.files;
      this.fileName = files[0].name;
      // console.log(this.fileName)
      this.file = files[0];
    },
    getFilter() {
      console.log(this.filterEmpId);
      this.employees = this.nofilterEmployees;
      var employee = [];
      if (this.filterEmpId != "") {
        this.newData = this.nofilterEmployees.filter(
          c =>
            c.employeeCode != null &&
            c.employeeCode.toLowerCase().match(this.filterEmpId.toLowerCase())
        );
      }
      if (this.filterEmpName != "" && this.filterDesignationId != "") {
        this.employees = this.nofilterEmployees.filter(
          c =>
            this.filterEmpName.toLowerCase().match(c.firstName.toLowerCase()) ||
            this.filterEmpName.toLowerCase().match(c.lastName.toLowerCase()) ||
            c.designationId == parseInt(this.filterDesignationId)
        );
      }
      if (this.filterEmpName != "" && this.filterDesignationId == "") {
        this.newData = this.nofilterEmployees.filter(c =>
          c.fullName.toLowerCase().includes(this.filterEmpName.toLowerCase())
        );
      }
      if (this.filterDesignationId != "") {
        this.newData = this.nofilterEmployees.filter(
          c => c.designationId == parseInt(this.filterDesignationId)
        );
      }
      if (
        this.filterEmpId == "" &&
        this.filterEmpName == "" &&
        this.filterDesignationId == ""
      ) {
        this.employees = this.nofilterEmployees;
      }
    },

    looksearch() {
      this.newData = this.nofilterEmployees.filter(c =>
        c.fullName.toLowerCase().includes(this.filterEmpName.toLowerCase())
      );
    },
    employeeCodesearch() {
      this.newData = this.nofilterEmployees.filter(
        c =>
          this.filterEmpId != null &&
          c.employeeCode.toLowerCase().includes(this.filterEmpId.toLowerCase())
      );
    },
    GetRanks() {
      organizationService.getRanks().then(
        model => {
          this.ranks = model;
          var rankStrings = "";
          model.forEach(t => {
            rankStrings += t.id + " - " + t.rankName + ", ";
          });
          this.rankStrings = rankStrings;
        },
        error => {
          this.error = error;
        }
      );
    },

    GetEmployees() {
      this.loading = true;
      var unit = JSON.parse(localStorage.getItem("companyUnit"));
      console.log(unit.id);

      employeeService.getEmployees(unit.id).then(
        model => {
          (this.employees = model), (this.nofilterEmployees = model);
          (this.loading = false), (this.companyUnitId = unit.id);

          this.newData = model.map(c => {
            return { ...c, fullName: c.firstName + " " + c.lastName };
          });
          this.nofilterEmployees = model.map(c => {
            return { ...c, fullName: c.firstName + " " + c.lastName };
          });

          console.log(this.newData, this.nofilterEmployees);
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },

    GetExitEmployees() {
      this.loading = true;
      employeeService.getExitEmployees(this.company.id).then(
        model => {
          (this.employees = model),
            (this.nofilterEmployees = model),
            (this.loading = false);

          this.newData = model.map(c => {
            return { ...c, fullName: c.firstName + " " + c.lastName };
          });
          this.nofilterEmployees = model.map(c => {
            return { ...c, fullName: c.firstName + " " + c.lastName };
          });
        },
        error => {
          (this.error = error), (this.loading = false);
        }
      );
    },

    importEmployee() {
      employeeService.importEmployee(this.company.id, this.file).then(
        response => {
          var unit = JSON.parse(localStorage.getItem("companyUnit"));
          employeeService.getEmployees(unit.id).then(model => {
            (this.employees = model), (this.filterEmployees = model);
            //this.message = '';
            this.dialogImport = false;
          });
        },
        error => {
          this.error = error;
        }
      );
    },

    importEmployeeDetail() {
      employeeService.importEmployeeDetail(this.company.id, this.file).then(
        response => {
          var unit = JSON.parse(localStorage.getItem("companyUnit"));
          employeeService.getEmployees(unit.id).then(model => {
            (this.employees = model), (this.filterEmployees = model);
            //this.message = '';
            this.dialogDImport = false;
          });
        },
        error => {
          this.error = error;
        }
      );
    },

    exportEmployee() {
      var unit = JSON.parse(localStorage.getItem("companyUnit"));
      employeeService.exportEmployee(unit.id).then(response => {
        let blob = new Blob([response.data], { type: response.data.type });
        // For the processing of the IE browser, CreateObjectURL is not supported by some IE browser
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, response.fileName);
        } else {
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob); // Create a download link
          downloadElement.href = href;
          downloadElement.download = response.fileName; // Download the file name
          document.body.appendChild(downloadElement);
          downloadElement.click(); // click to download
          document.body.removeChild(downloadElement); // Download complete removal element
          window.URL.revokeObjectURL(href); // Release Blob object
        }
      });
    },

    exitEmployee() {
      employeeService.exitAutoEmployee(this.employee.id).then(response => {
        var unit = JSON.parse(localStorage.getItem("companyUnit"));
          employeeService.getEmployees(unit.id).then(model => {
            (employees = model), (this.filterEmployees = model);
            closeExit();
          });
      });
    },

    reconsiderEmployee() {
      this.loading = true
      employeeService.reconsiderEmployee(this.employee.id).then(response => {
        this.loading = false
        var unit = JSON.parse(localStorage.getItem("companyUnit"));
          employeeService.getEmployees(unit.id).then(model => {
            (employees = model), (this.filterEmployees = model);
            closeExit();
          });
      });
    },

    downloadTemplate() {
      employeeService
        .downloadEmployeeTemplate(this.company.id)
        .then(response => {
          let blob = new Blob([response.data], { type: response.data.type });
          // For the processing of the IE browser, CreateObjectURL is not supported by some IE browser
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, response.fileName);
          } else {
            var downloadElement = document.createElement("a");
            var href = window.URL.createObjectURL(blob); // Create a download link
            downloadElement.href = href;
            downloadElement.download = response.fileName; // Download the file name
            document.body.appendChild(downloadElement);
            downloadElement.click(); // click to download
            document.body.removeChild(downloadElement); // Download complete removal element
            window.URL.revokeObjectURL(href); // Release Blob object
          }
        });
    },

    setEmployee(employee) {
      this.employee = employee;
    },

    removeEmployee() {
      //   if(this.employee){
      employeeService.removeEmployee(this.employee.id).then(
        id => {
          var unit = JSON.parse(localStorage.getItem("companyUnit"));
          employeeService.getEmployees(unit.id).then(model => {
            (employees = model), (this.filterEmployees = model);
          });
        },
        error => {
          this.error = error;
        }
      );
      //   }
    },

    setEditEmployee(model) {
      this.employee = model;
      this.dialogEdit = true;
    },

    setDeletEmployee(model) {
      this.employee = model;
      this.dialogDelete = true;
    },
    setExitEmployee(model) {
      this.employee = model;
      this.dialogExit = true;
    },

    setConsiderEmployee(model) {
      this.employee = model;
      this.dialogConsider = true
    },

    onSubmit() {
      this.submitted = true;

      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.loading = true;
      employeeService
        .addEmployee(
          this.company.id,
          this.rankId,
          this.firstName,
          this.lastName,
          this.email,
          this.phone,
          this.employeeCode,
          this.designationId,
          this.companyunitId,
          this.joinedDate,
          this.branch,
          this.district
        )
        .then(
          id => {
            this.message = "New Employee Added successfully";
            var unit = JSON.parse(localStorage.getItem("companyUnit"));
            this.GetEmployees();
            employeeService.getEmployees(unit.id).then(model => {
              (this.employees = model), (this.filterEmployees = model);
              this.close1();
              //this.message = '';
            });
          },
          error => {
            this.error = error;
            this.loading = false;
          }
        );
    },

    onPutSubmit() {
      this.submitted = true;
      employeeService.updateEmployee(this.employee.id, this.employee).then(
        id => {
          this.message = "Employee update successfully";
          var unit = JSON.parse(localStorage.getItem("companyUnit"));
          employeeService.getEmployees(unit.id).then(model => {
            this.employees = model;
            this.close2();
          });
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },

    clearModel() {
      this.firstName = "";
      this.lastName = "";
      this.rankId = null;
      this.address = "";
      this.phone = "";
      this.employeeCode = "";
      this.email = "";
      this.designationId = null;
      this.newEmployeeDesignation = null;
      this.selectRank = null;
      this.companyunitId = null;
      // this.employee = null;
      this.error = "";
      this.message = "";
    },

    close1() {
      this.dialogAdd = false;
      this.clearModel();
    },

    openDialog() {
      this.dialogAdd = true;
    },

    openImportDialog() {
      this.dialogImport = true;
    },
    openImportDDialog() {
      this.dialogDImport = true;
    },
    close2() {
      this.dialogEdit = false;
    },

    closeDelete() {
      this.dialogDelete = false;
    },
    closeExit() {
      this.dialogExit = false;
    },
    closeImport() {
      this.dialogImport = false;
    },
    closeDImport() {
      this.dialogDImport = false;
    },
    closeConsider() {
      this.dialogConsider = false;
    }
  },

  mounted() {
    this.GetRanks();
    this.GetDesignations();
    this.GetUnits();

    // Date Time Picker

    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }
    // Datatable
    if ($(".datatable").length > 0) {
      $(".datatable").DataTable({
        bFilter: false
      });
    }

    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "employeeslist"
};
</script>



// WEBPACK FOOTER //
// src/components/employees/main.vue